import React, { useState, useCallback } from 'react';
import {
  Stepper,
  Step,
  StepButton,
  StepLabel,
  StepContent,
  Button,
  Typography,
  TextField,
  Box,
} from '@mui/material';

const questions = [
  { id: 1, prompt: 'Place an adverb. For example: boldly; quickly; patiently.', placeholder: 'mostly' },
  { id: 2, prompt: "What is your best friend's name?", placeholder: 'Joe' },
  { id: 3, prompt: 'What sport do you and your best friend like to play together?', placeholder: 'soccer' },
  { id: 4, prompt: 'What verb do you do with your best friend?', placeholder: 'bounce' },
  { id: 5, prompt: 'What is an adjective of this friend?', placeholder: 'strong' },
  { id: 6, prompt: "Write some person's name.", placeholder: 'Bob' },
  { id: 7, prompt: 'What is a adjective of this person you do not like?', placeholder: 'mean' },
  { id: 8, prompt: 'What is something that you have (singular)?', placeholder: 'ball' },
  { id: 9, prompt: 'What is something that your best friend have (singular)?', placeholder: 'skyscraper' },
  { id: 10, prompt: 'Place an adjective to a dirty sock.', placeholder: 'dirty' },
  { id: 11, prompt: 'What is your favorite thing to drink?', placeholder: 'pop' },
];

function VerticalLinearStepper() {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());
  const [answers, setAnswers] = useState(
    questions.map((q) => ({ id: q.id, answer: '' }))
  );

  const totalSteps = questions.length;
  const completedSteps = completed.size;
  const skippedSteps = skipped.size;
  const allStepsCompleted = completedSteps === totalSteps - skippedSteps;
  const isLastStep = activeStep === totalSteps - 1;

  const handleBack = useCallback(() => {
    setActiveStep((prev) => prev - 1);
  }, []);

  const handleSkip = useCallback(() => {
    setSkipped((prev) => {
      const newSkipped = new Set(prev);
      newSkipped.add(activeStep);
      return newSkipped;
    });
    setActiveStep((prev) => prev + 1);
  }, [activeStep]);

  const handleStep = useCallback((step) => () => {
    setActiveStep(step);
  }, []);

  const handleChange = useCallback((id, value) => {
    setAnswers((prev) =>
      prev.map((answer) =>
        answer.id === id ? { ...answer, answer: value } : answer
      )
    );
  }, []);

  const handleComplete = useCallback(
    (key) => {
      if (key !== undefined && key !== 'Enter') return;

      const newCompleted = new Set(completed);
      newCompleted.add(activeStep);
      setCompleted(newCompleted);

      if (newCompleted.size !== totalSteps - skippedSteps) {
        // Find next incomplete step
        const nextStep = isLastStep
          ? questions.findIndex((_, i) => !newCompleted.has(i))
          : activeStep + 1;
        setActiveStep(nextStep);
      } else {
        setActiveStep(totalSteps);
      }
    },
    [activeStep, completed, isLastStep, skippedSteps, totalSteps]
  );

  const handleReset = useCallback(() => {
    setActiveStep(0);
    setCompleted(new Set());
    setSkipped(new Set());
    setAnswers(questions.map((q) => ({ id: q.id, answer: '' })));
  }, []);

  const isStepComplete = useCallback(
    (step) => completed.has(step),
    [completed]
  );

  const renderAnswer = useCallback(
    (index) => {
      return answers[index].answer !== ''
        ? answers[index].answer
        : questions[index].placeholder;
    },
    [answers]
  );

  return (
    <Box>
      {completedSteps !== totalSteps && (
        <Stepper nonLinear activeStep={activeStep} orientation="vertical">
          {questions.map((question, index) => (
            <Step key={question.id} completed={isStepComplete(index)}>
              <StepButton onClick={handleStep(index)}>
                <StepLabel>
                  {completed.has(index)
                    ? `${question.prompt} (Completed)`
                    : question.prompt}
                </StepLabel>
              </StepButton>

              <StepContent>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  placeholder={question.placeholder}
                  fullWidth
                  margin="normal"
                  value={answers[index].answer}
                  onChange={(e) => handleChange(question.id, e.target.value)}
                  onKeyPress={(e) => handleComplete(e.key)}
                  autoFocus={index === activeStep}
                />
                <Box sx={{ mb: 2 }}>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    Back
                  </Button>
                  {completed.has(activeStep) && !allStepsCompleted ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleComplete('Enter')}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Next
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleComplete('Enter')}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      {completedSteps === totalSteps - 1
                        ? 'Finish'
                        : 'Complete Question'}
                    </Button>
                  )}
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      )}

      {completedSteps === totalSteps && (
        <Typography>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;My friend {renderAnswer(1)}
          {/* bf */} is like {renderAnswer(5)}
          {/* persons_name */}. They are both {renderAnswer(4)}
          {/* persons_description */}. Unlike {renderAnswer(5)}
          {/* persons_name */}, {renderAnswer(1)}
          {/* bf */} has a {renderAnswer(8)}
          {/* noun */}. If you think about it, {renderAnswer(5)} is not so sweet
          because {renderAnswer(1)} has a {renderAnswer(8)}. Also,{' '}
          {renderAnswer(1)} is so much {renderAnswer(4)}
          er, and that makes my {renderAnswer(7)} rock it's socks off. I know
          that my {renderAnswer(7)} might not have socks but if it did, I am
          just saying, I know {renderAnswer(1)} would take the {renderAnswer(7)}
          's socks and turn them into {renderAnswer(9)} socks and then give the{' '}
          {renderAnswer(9)} socks to {renderAnswer(5)} as a gift!
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Anyways, {renderAnswer(5)} is a{' '}
          {renderAnswer(6)} person that has to be with my best friend and I all
          the time, especially when we {renderAnswer(3)} together. But we like
          to have some fun with this {renderAnswer(6)} person. For example, we
          play {renderAnswer(2)} a lot and when playing, we make fun of{' '}
          {renderAnswer(5)}'s clumsy mistakes! We laugh throughout the game of{' '}
          {renderAnswer(2)}. After a game of much fun, {renderAnswer(1)} and I
          take it back to my place and crack open a couple of {renderAnswer(10)}
          s and sit back reflecting on the {renderAnswer(2)} game. We{' '}
          {renderAnswer(0)} point out how poor {renderAnswer(5)}'s performance
          was.
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{renderAnswer(1)} is totally not like{' '}
          {renderAnswer(5)} because {renderAnswer(5)} does not {renderAnswer(3)}{' '}
          like us. We have been always using our {renderAnswer(3)}
          ing skills against {renderAnswer(5)}, the {renderAnswer(6)} head.
          Sometimes {renderAnswer(1)} and I are good friends with{' '}
          {renderAnswer(5)}. We {renderAnswer(0)} point out to our friend{' '}
          {renderAnswer(5)} how they did not play {renderAnswer(2)} that good or
          not good at all. As a solution, we tell {renderAnswer(5)} as polite as
          we can that they can not play {renderAnswer(2)}. We get to the point
          that {renderAnswer(5)} straight up sucks at {renderAnswer(2)} and
          should not play {renderAnswer(2)}. After telling a solution to their
          problems, we start laughing at our {renderAnswer(6)} friend and tell{' '}
          {renderAnswer(5)} that {renderAnswer(1)} gave them a sock from my{' '}
          {renderAnswer(7)}'s feet, and made it a {renderAnswer(9)} sock as a
          gift, to them. Yea that's right- as a prank! We got {renderAnswer(5)}{' '}
          good.
        </Typography>
      )}

      {completedSteps === totalSteps && (
        <Box>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default VerticalLinearStepper;
